import React from 'react';
import Select from 'react-select';
import { getTranslation } from '../../../../../utils/translation';
import { TICKET_SOURCES } from '../../../../../constants/enums';

const Source = ({ selectedSource, onSourceChange }) => {
    const ticketSources = [
        { label: getTranslation('ticketsFiltersSourcesAll'), value: TICKET_SOURCES.all },
        { label: getTranslation('ticketsFiltersSourcesCashier'), value: TICKET_SOURCES.cashier },
        { label: getTranslation('ticketsFiltersSourcesTerminal'), value: TICKET_SOURCES.terminal },
    ];

    const selectedSourceOption = ticketSources.find(option => option.value === selectedSource);

    return (
        <Select
            className='common-select common-select--filters'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedSourceOption}
            onChange={onSourceChange}
            options={ticketSources}
        />
    );
};

export default Source;
